export class ApiError extends Error {
  status: number
  body: unknown
  constructor(message: string, status: number, body: unknown) {
    super(message)
    this.status = status
    this.body = body
  }
}

export async function api_json<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers || {})
  if (!headers.has('Content-Type') && !(init.body instanceof FormData)) {
    headers.set('Content-Type', 'application/json')
  }

  const res = await fetch(path, {
    ...init,
    headers,
    credentials: 'include',
    // Evita reaproveitar /api/auth/me com user:null após login (cache HTTP do browser).
    cache: init.cache ?? 'no-store'
  })

  const text = await res.text()
  const body = text ? safe_json_parse(text) : null

  if (!res.ok) {
    throw new ApiError(`API error (${res.status})`, res.status, body)
  }

  return body as T
}

function safe_json_parse(text: string): unknown {
  try {
    return JSON.parse(text)
  } catch {
    return { raw: text }
  }
}
